import React from 'react'

const Google = () => {
  return (
    <h1>Google</h1>
  )
}

export default Google